import { render } from "./Input.vue?vue&type=template&id=c816ecd2&scoped=true"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c816ecd2"

export default script